import { IReleaseNote } from "../types"

export const RELEASE_1_3_4: IReleaseNote = {
    status: "PAST",
    title: "v1.3.4",
    date: "12th August 2024",
    releaseType: "Patch",
    notesBodyAllUsers: [
        {
            heading: "Introduction",
            content:
                "This is a patch release to onboard iDNO Harlaxton Energy Networks Limited onto ENA Connect Direct!",
        },
    ],
    notesBodyInstaller: [
        {
            heading: "For installers using the web portal",
            content: "The following changes have been added:",
            bullets: [
                "You can now submit applications for customers in the Harlaxton Energy Networks Limited license area",
            ],
        },
        {
            heading: "For installers using our APIs",
            content: "The following change has been added:",
            bullets: [
                "You can now submit applications for customers in the Harlaxton Energy Networks Limited license area",
                "The abbreviation for this iDNO is 'I-HENL'",
            ],
        },
    ],
    notesBodyDno: [
        {
            heading: "For DNOs using the web portal",
            content: "This release contains no changes to your functionality",
        },
        {
            heading: "For DNOs using our APIs",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyManu: [
        {
            heading: "For manufacturers using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorDemand: [
        {
            heading: "For demand evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
    notesBodyDbAssessorGen: [
        {
            heading: "For generation evaluators using the web portal",
            content: "This release contains no changes to your functionality",
        },
    ],
}
